import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { propertyTypologyActions } from '../../store/propertyTypologies/actions';
import { getPropertyTypologiesState } from '../../store/propertyTypologies/reducer';
import { useAppDispatch, useAppSelector } from '../redux/store';

export default function usePropertyTypologies() {
  const { propertyTypologies } = useAppSelector(getPropertyTypologiesState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isEmpty(propertyTypologies)) {
      dispatch(propertyTypologyActions.fetchPropertyTypologies.request());
    }
  }, []);

  const reducedPropertyTypologies = () =>
    isEmpty(propertyTypologies)
      ? []
      : propertyTypologies.filter((e) =>
          ['Maison', 'Appartement', 'Terrain'].includes(e.name),
        );

  return { propertyTypologies, reducedPropertyTypologies };
}
